import {ToolPersona} from "@khan/khanmigo-tools";

import {PARENT_KHANMIGO_TOOLS_PATH} from "#page-package/util.ts";

import {
    ADMIN_KHANMIGO_TOOLS_PATH,
    TEACHER_KHANMIGO_TOOLS_PATH,
} from "../khanmigo/path-helpers.ts";
import {Platform} from "../khanmigo/utils.ts";

export const createResumeDocumentHref = (
    aiToolsSlug: string,
    threadId: string,
    persona: ToolPersona,
    platform?: string,
): string => {
    const toolsPath =
        persona === ToolPersona.Parent
            ? PARENT_KHANMIGO_TOOLS_PATH
            : persona === ToolPersona.Admin
              ? ADMIN_KHANMIGO_TOOLS_PATH
              : TEACHER_KHANMIGO_TOOLS_PATH;

    let baseURL = `${toolsPath}/${aiToolsSlug}?resumeThreadId=${threadId}`;

    if (platform === Platform.Canvas) {
        baseURL = `${baseURL}&platform=${Platform.Canvas}`;
    }

    return baseURL;
};

export const createViewDocumentHref = (
    documentID: string,
    persona: ToolPersona,
): string => {
    const docPath =
        persona === ToolPersona.Parent
            ? `/parent/document`
            : persona === ToolPersona.Admin
              ? `/districts/khanmigo-documents`
              : `/teacher/document`;
    return `${docPath}/${documentID}/view`;
};

export const formatDate = (isoDate: string): string => {
    const date = new Date(isoDate);
    const options: Intl.DateTimeFormatOptions = {
        month: "long",
        day: "numeric",
        year: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
};

export const convertToFileNameFormat = (str: string): string => {
    const formattedStr = str.trim().toLowerCase().replace(/\s+/g, "-");
    return formattedStr;
};
